import Lenis from 'lenis';

// Initialize Lenis
const lenis = new Lenis();

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// pause when modal is open
$('.page-wrapper').on('lenisStop', function () {
    //console.log('stop Lenis');

    lenis.stop();
}).on('lenisStart', function () {
    //console.log('restart Lenis');

    lenis.start();
});
